import { Component, inject } from '@angular/core';
import { OfficeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  OfficeCreateDto,
  OfficeDto,
  OfficeExcelDownloadDto,
  OfficeUpdateDto,
} from '../proxy/planning/dtos/office';
import { OFFICE_CONFIG, OFFICE_FIELDS } from './office.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-office',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, OfficeService, ConfirmationService],
  templateUrl: './office.html',
  styleUrl: './office.scss',
})
export class Office extends BaseHierarchicalCrudComponent<
  OfficeDto,
  OfficeCreateDto,
  OfficeUpdateDto,
  OfficeExcelDownloadDto
> {
  service = inject(OfficeService);
  config = OFFICE_CONFIG;
  fields = OFFICE_FIELDS;

  protected prepareUpdateDto(data: any, selected: OfficeDto): OfficeUpdateDto {
    return {
      name: data.name,
      zoneId: data.zoneId,
      locationId: data.locationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Office';
  }
}
